import { createSelector } from 'reselect';

import getApplicationSelector from '/business/shared/state/selectors/application/getApplicationSelector';

export default createSelector([getApplicationSelector], (application) => {
  const carbonIntensity = application?.emissions?.scope2EmissionsCarbonIntensity;
  return carbonIntensity;
});
